import { render, staticRenderFns } from "./AppApiAgentsRegenerateButton.vue?vue&type=template&id=67c5527c"
import script from "./AppApiAgentsRegenerateButton.vue?vue&type=script&lang=js"
export * from "./AppApiAgentsRegenerateButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports